<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="handleFilter"
        style="width: 200px; margin-right: 20px"
        class="filter-item"
        placeholder="输入名称"
        v-model="listQuery.name"
        size="small"
      >
      </el-input>
      <el-button
        style="width: 100px"
        class="filter-item"
        type="primary"
        icon="search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
    </template>
    <el-button
      class="filter-item"
      v-permission:function="['elementType:btn_add']"
      style="margin-left: 10px"
      @click="handleCreate"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      >添加</el-button
    >
    <el-table
      :key="tableKey"
      :data="list"
      v-loading.body="listLoading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column align="center" label="序号" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" style="color: green">启用</span>
          <span v-if="scope.row.status === 1" style="color: red">禁用</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" label="修改时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-permission:function="['elementType:btn_edit']"
            size="small"
            type="success"
            @click="handleUpdate(scope.row)"
            >编辑
          </el-button>
          <el-button
            v-permission:function="['elementType:btn_del']"
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-show="!listLoading" class="pagination-container"> -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </template>
    <!-- </div> -->
    <el-dialog
      center
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            class="filter-item"
            v-model="form.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-table
          :data="regList"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
          tooltip-effect="dark"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            property="id"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column
            property="elementName"
            label="名称"
            width="200"
          ></el-table-column>
          <el-table-column
            property="extractRegex"
            label="正则"
          ></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button
          v-if="dialogStatus == 'create'"
          type="primary"
          @click="create('form')"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="update('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj,
} from "@/api/sysTool/elementType/index";
import { getAllReg } from "@/api/sysTool/regex/index";
import { mapGetters } from "vuex";
export default {
  name: "elementType",
  data() {
    return {
      multipleSelection: [],
      form: {
        id: undefined,
        name: undefined,
        status: 0,
        regList: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
      },
      statusOptions: [
        { label: "启用", value: 0 },
        { label: "禁用", value: 1 },
      ],
      dialogFormVisible: false,
      dialogStatus: "",
      elementType_btn_edit: this.hasPermissions(["elementType:btn_edit"]),
      elementType_btn_del: false,
      elementType_btn_add: false,
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
      regList: [],
    };
  },
  created() {
    this.getList();
    getAllReg().then((res) => {
      this.regList = res;
    });
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      this.resetTemp();
      getObj(row.id).then((response) => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = "update";
        this.toggleSelection(response.regList);
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then(() => {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          addObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj( this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "更新成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    toggleSelection(rows) {

      if (rows) {
        this.$nextTick(() => {
          rows.forEach((row) => {
            console.log(this.$refs.multipleTable);
            this.$refs.multipleTable.toggleRowSelection(this.regList.find(item=>{
      	        return row.id == item.id;  // 注意这里寻找的字段要唯一，示例仅参考
   	        }),true);

          });
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.form.regList = val;
    },
    resetTemp() {
      this.form = {
        name: undefined,
        status: undefined,
        regList:[]
      };
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      
    },
  },
};
</script>
